import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import UserDropdown from '../../system-administrator/components/UserDropdown';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const SuperAdminDialog = ({
    visible,
    onHide,
    formData,
    setFormData,
    onSave,
    userList,
    isLoadingUsers,
    isAdding
}) => {
    const { th } = useLanguage();

    const footerContent = (
        <div className="flex justify-content-end gap-2">
            <Button label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} disabled={isAdding} />
            <Button label={th('common.save')} icon="pi pi-check" onClick={onSave} loading={isAdding} disabled={isAdding} />
        </div>
    );

    return (
        <Dialog
            header={th('superAdminDefinition.newTitle')}
            visible={visible}
            style={{ width: '520px' }}
            modal
            footer={footerContent}
            onHide={onHide}
            closable={!isAdding}
        >
            <div className="grid p-2">
                <div className="col-12">
                    <Message severity="info" className="w-full mb-3" text={th('superAdminDefinition.claimInfo')} icon="pi pi-info-circle" />
                </div>

                <div className="col-12">
                    <div className="field">
                        <label className="font-bold block mb-2">
                            {th('superAdminDefinition.user')} <span className="text-red-500">*</span>
                        </label>
                        <UserDropdown
                            value={formData.userId}
                            onChange={(value) => setFormData((prev) => ({ ...prev, userId: value }))}
                            userList={userList}
                            isLoading={isLoadingUsers}
                            disabled={isAdding}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default SuperAdminDialog;
